// Build version for deployment verification
// Update this version with each significant deploy
export const BUILD_VERSION = "4.65.0";
export const BUILD_DATE = "2026-07-23T18:00:00-06:00";
export const BUILD_NOTES = "v4.65.0: P0 Contratos/Calendario. (Inc1/3) get_contracts: cap 1000→5000 + búsqueda server-side por folio/cliente/ruta (soluciona contratos que no aparecían/no se encontraban por truncación). (Inc2) Calendario 'Ver Contrato Completo' navega al contract_id REAL (no al id compuesto uuid__line). (Inc4/D) Calendario excluye contratos cancelados (no eventos huérfanos). Incluye fixes previos v4.61-v4.64.";

// Environment detection
export const getEnvironment = () => {
  const hostname = window.location.hostname;
  if (hostname.includes('preview.emergentagent.com')) {
    return 'Preview';
  } else if (hostname.includes('localhost') || hostname.includes('127.0.0.1')) {
    return 'Local';
  } else {
    return 'Producción';
  }
};
